import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const NoSearchResultsIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.7472 19.8802L23.7992 23.8002M22.4926 13.3469C22.4926 18.3984 18.3974 22.4935 13.3459 22.4935C8.29432 22.4935 4.19922 18.3984 4.19922 13.3469C4.19922 8.2953 8.29432 4.2002 13.3459 4.2002C18.3974 4.2002 22.4926 8.2953 22.4926 13.3469Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 11L11 16M16 16L11 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

NoSearchResultsIcon.displayName = 'NoSearchResultsIcon';
